export default __webpack_public_path__ + "static/media/lasko-back.1a915c34.jpg";